import { render, staticRenderFns } from "./TableSandbox.vue?vue&type=template&id=d8bcd356&scoped=true"
import script from "./TableSandbox.vue?vue&type=script&lang=js"
export * from "./TableSandbox.vue?vue&type=script&lang=js"
import style0 from "./TableSandbox.vue?vue&type=style&index=0&id=d8bcd356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bcd356",
  null
  
)

export default component.exports